import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";

const ReBidSuccessBox = ({ userType = "Buyer", open, onCancel, onOk }) => {
  return (
    <div className="">
      <DiaglogBox
        open={open}
        onOk={onOk}
        onCancel={onCancel}
        width={400}
        className
      >
        <div className="drop-shadow-custom">
          <div className="relative">
            <div className="flex justify-center items-center absolute top-0 left-0 w-full h-full">
              <img src="/images/greentick.svg" alt="" />
            </div>
            <div className="w-full h-1/3">
              <img
                src="/images/green.svg"
                alt=""
                className="w-full mt-[-1.3rem]"
              />
            </div>
          </div>

          <h1 className="text-center text-black mt-2 mb-2 text-[20px] font-medium">
            Price Re-Bided Successfully!
          </h1>

          <div className="flex justify-center mt-7 pb-8">
            <Button
              varient="primary"
              borderColor="blue"
              className=" w-[7.5rem] h-[2.5rem] text-[14px] text-white font-bold  bg-blue-800   "
              onClick={onOk}
            >
              Go back
            </Button>
          </div>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default ReBidSuccessBox;
